import type { WizardPreview, WizardProvisionedCredential } from "@/types/wizard";

export function credentialsToEnv(credentials: WizardProvisionedCredential[]): string {
  const lines: string[] = [];
  for (const cred of credentials) {
    const prefix = cred.key.replace(/[^a-zA-Z0-9]/g, "_").toUpperCase();
    lines.push(`# ${cred.name} (${cred.type})`);
    lines.push(`${prefix}_CLIENT_ID=${cred.clientId}`);
    if (cred.clientSecret) {
      lines.push(`${prefix}_CLIENT_SECRET=${cred.clientSecret}`);
    }
    lines.push(`${prefix}_SUBJECT=${cred.subject}`);
    lines.push("");
  }
  return lines.join("\n").trimEnd();
}

export function previewToJson(result: WizardPreview): string {
  return JSON.stringify(result, null, 2);
}
